<template>
  <div id="AppPasswordForceChange" class="login-background-color">
    <img src="@/assets/logo.png" style="height: 250px; margin: 50px" />
    <div>
      <p>Philips Care Portal</p>
    </div>
      <section style="width: 500px; margin: auto">
        <template v-if="isInitialPassword">
          <b-field label="初期パスワードを変更してください。" />
        </template>
        <template v-else>
          <b-field
            v-if="roleId == role.role_admin"
            label="前回パスワード変更から60日以上経過しています。"
          />
          <b-field
            v-else
            label="前回パスワード変更から90日以上経過しています。"
          />
          <b-field label="パスワードを変更してください。" />
        </template>
        <b-field label="" />
        <b-field
          label="新しいパスワード"
          :type="{ 'is-danger': errors.has('afterPassword') }"
          :message="errors.first('afterPassword')"
        >
          <b-input
            name="afterPassword"
            data-vv-as="新しいパスワード"
            type="password"
            ref="afterPassword"
            v-model="newpassword"
            password-reveal
            placeholder="新しいパスワードを入力してください"
            v-validate="'required|min:8|password'"
            @keydown.enter.native="passwordAreaEnter"
          ></b-input>
        </b-field>
        <b-field
          label="新しいパスワード(確認)"
          :type="{ 'is-danger': errors.has('afterPasswordcomf') }"
          :message="errors.first('afterPasswordcomf')"
        >
          <b-input
            name="afterPasswordcomf"
            data-vv-as="新しいパスワード(確認)"
            type="password"
            v-model="newpasswordcomf"
            password-reveal
            placeholder="新しいパスワード(確認)を入力してください"
            v-validate="'required|confirmed:afterPassword'"
            @keydown.enter.native="passwordAreaEnter"
          ></b-input>
        </b-field>
        <tr>
          <th></th>
          <td>※パスワードは8桁以上5文字以上の異なる文字で入力してください。</td>
        </tr>
      </section>
      <footer class="login-footer" >
        <div>
          <b-button
            class="button is-light is-inverted has-text-centered"
            icon-left="key-change"
            :disabled="!isActive"
            v-on:click="passwordForceChange()"
            style="
              width: 500px;
              margin: 0 0 5px 0;
              background-color: #00325d;
              color: whitesmoke;
            "
            >パスワード変更</b-button
          >
        </div>
      </footer>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
export default {
  name: "AppPasswordForceChange",
  data() {
    let roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    return {
      role: role,
      roleId: roleId,
      isInitialPassword: true,
      currentpassword: "",
      newpassword: "",
      newpasswordcomf: "",
      isActive: true,
      introductionQuery:
        this.$route.query && this.$route.query.query
          ? this.$route.query.query
          : "",
    };
  },
  created() {
    this.currentpassword = this.$route.params.currentpassword;
    this.isInitialPassword = this.$route.params.isInitialPassword;
  },
  methods: {
    passwordForceChange: function (event) {
      this.isActive = false;
      console.log("password force change called.");
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.currentpassword == this.newpassword) {
            this.showErrorMessage("変更前と違うパスワードを入力してください。");
            this.isActive = true;
          } else {
            //newパスワードの形式チェック
            if (this.newpassword.length < 8) {
              this.showErrorMessage(
                "変更後パスワードは8文字以上で指定してください。"
              );
              this.isActive = true;
              return;
            } else if (this.newpassword.length > 256) {
              this.showErrorMessage(
                "変更後パスワードは256文字以下で指定してください。"
              );
              this.isActive = true;
              return;
            } else {
              var array1 = this.newpassword.split("");
              var array2 = Array.from(new Set(array1));
              if (array2.length < 5) {
                this.showErrorMessage(
                  "変更後パスワードは5文字以上の異なる文字を使用してください。"
                );
                this.isActive = true;
                return;
              }
            }
            this.$store
              .dispatch("passwordForceChange", {
                currentpassword: this.currentpassword,
                newpassword: this.newpassword,
              })
              .then((result) => {
                console.log(result);
                if (result != null && result.status === 200) {
                  this.isActive = true;
                  this.showSuccess(result, this.goToHome);
                } else if (
                  result != null &&
                  (result.status === 400 ||
                    result.status === 401 ||
                    result.status === 500)
                ) {
                  var message = "予期しないエラーが発生しました。";
                  if (result.response.body) {
                    message = result.response.body.message;
                  } else if (result.message) {
                    message = esult.message;
                  }
                  this.showErrorMessage(message);
                  this.isActive = true;
                } else {
                  this.isActive = true;
                  this.showErrorMessage("予期しないエラーが発生しました。");
                }
              })
              .catch((error) => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。");
                this.isActive = true;
              });
          }
        } else {
          this.isActive = true;
        }
      });
    },
    passwordAreaEnter: function() {
      if(this.newpassword && this.newpasswordcomf){
        this.passwordForceChange();
      }
    },
    goToHome: function () {
      if (
        this.roleId == this.role.role_admin ||
        this.roleId == this.role.role_headOffice ||
        this.roleId == this.role.role_headOffice_sales ||
        this.roleId == this.role.role_headOffice_division ||
        this.roleId == this.role.role_headOffice_sw ||
        this.roleId == this.role.role_salesOffice ||
        this.roleId == this.role.role_psc ||
        this.roleId == this.role.role_kawagoe ||
        this.roleId == this.role.role_kawagoe_cpap ||
        this.roleId == this.role.role_call_center ||
        this.roleId == this.role.role_headOffice_call ||
        this.roleId == this.role.role_ndss
      ) {
        //内部ユーザー
        this.$router.push({ path: "/philips/home" });
      } else {
        //外部ユーザー
        if (this.introductionQuery) {
          // 転院紹介
          this.isActive = false;
          var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          this.$store
            .dispatch("verifyKeyForIntroductionRequestAuth", {
              query: this.introductionQuery,
              token: userInfo.token,
            })
            .then((result) => {
              this.isActive = true;
              if (result != null && result.status === 200) {
                if (result.body.resultDownload) {
                  this.goToResultDownload(result.body.resultDownload);
                } else {
                  this.goToRequest(
                    result.body.prekind,
                    result.body.serviceId,
                    result.body.receptionNo
                  );
                }
              } else if (result != null && result.status === 400) {
                this.showErrorMessage(result.response.body.message);
              } else {
                this.showErrorMessage("予期しないエラーが発生しました。");
              }
            });
        } else {
          this.$router.push({ path: "/guest/home" });
        }
      }
    },
    goToRequest: async function (prekind, serviceId, receptionNo) {
      var loadMasterList = [];
      loadMasterList.push(this.getOfficeMaster())
      loadMasterList.push(this.getStatusMaster())
      loadMasterList.push(this.getAuthMaster())
      loadMasterList.push(this.getKindMaster())
      loadMasterList.push(this.getChoiceMaster())

      var userInfo = this.getUserInfo();
      if (this.isEnableService(userInfo.useServiceId, service.cpap)) {
        loadMasterList.push(this.getPrescriptionHardware())
        loadMasterList.push(this.getCpapStatusMaster())
        loadMasterList.push(this.getCpapCommonMaster())
        loadMasterList.push(this.getCpapItemMaster())
      }

      var appVue = this.$root.$children[0]
      appVue.loadingStart()

      await Promise.all (loadMasterList)
      .then ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み 正常終了");
      })
      .catch ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み エラー終了\nerrorlog : " + response.message);
      });
      this.$router.push({
        name: this.getRequestComponent(serviceId),
        params: {
          kind: prekind,
          receiptNumber: receptionNo,
          id: prekind == "holder" ? "easy" : "full", // PSG解析
          introduction: true,
        },
      });
      return;
    },
    goToResultDownload: function (result) {
      this.$router.push({
        name: "ResultDownload",
        params: {
          result: result,
        },
        query: {
          query: this.introductionQuery,
        },
      });
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.passphrase_txt {
  margin-left: 30px;
  margin-bottom: 32px;
  text-align: left;
}
.modal-card-head,
.modal-card-foot {
  background: linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
}
.modal-card-title {
  color: whitesmoke;
}
.login-background-color {
  background: -moz-radial-gradient(#0077cd 20%, #00325d 85%);
  background: -webkit-radial-gradient(#0077cd 20%, #00325d 85%);
  background: radial-gradient(#0077cd 20%, #00325d 85%);
  height: 100%;
  width: 100%;
  position: absolute;
  transform-origin: 0% 0%;
}
.login-background-color > div {
  margin: auto;
}
.login-background-color > div > p {
  color: whitesmoke;
  font-size: 35px;
  margin: 0 0 40px 0;
}
.login-footer {
  margin: 50px 0 0 0;
  width: 500px;
  display: inline-block;
}
.login-background-color > section > div > label {
  color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/AppPasswordForceChange.vue